import { type PartialDeep } from 'type-fest';

import {
  type CanvasElementFrom,
  type CanvasElementType,
  type PartialPropsOf,
  type PropsOf,
} from '@blaze-runtime/engine-domain';

import { hasTransformHistory } from './element-props-guards';

export const getSourceProps = <S extends CanvasElementType>(
  source: CanvasElementFrom<S>,
): PartialDeep<PropsOf<S>> => (source as any).props || {};

export const getSourceTransforms = <S extends CanvasElementType, T extends CanvasElementType>(
  source: CanvasElementFrom<S>,
  type: T,
): PartialPropsOf<T> | undefined => {
  if (!hasTransformHistory(source)) {
    return undefined;
  }

  return source.props.transforms[type] as PartialPropsOf<T> | undefined;
};
